export type ChatType = 'referral' | 'partner-match' | 'network' | 'sneak'

export enum ChatTypeEnum {
  REFERRAL = 'referral',
  PARTNER_MATCH = 'partner-match',
  NETWORK = 'network',
  SNEAK = 'sneak',
}
